export const inspectList = [
  {
    content: "모든 작업자는 언제나 안전모·안전대 등 보호구를 착용한다.",
    isChecked: "",
    title: "보호구 착용",
  },
  {
    content: "추락 위험이 있는 모든 장소(개구부, 단부, 작업발판 및 통로의 끝 등)에 안전난간, 울타리, 수직형 추락방망 또는 덮개를 설치하고, 난간 등의 설치가 어려운 경우<br/>" + "      추락방호 망을 설치한다. ",
    isChecked: "",
    title: "추락방지 설비",
  },
  {
    content: "임시로 난간 등을 해체하거나 추락방호망을 설치하기 어려운 경우, 작업자에게 안전대를 착용하도록 한다. ",
    isChecked: "",
    title: "추락방지 설비",
  },
  {
    content: "작업자에게 안전대를 착용하게 하는 경우, 안전대 부착설비를 설치하고 작업 시작 전 설비의 이상 유무를 점검한다.",
    isChecked: "",
    title: "추락방지 설비",
  },
  {
    content: "강관비계보다 시스템비계*를 사용한다.<br/>" + "       *공장에서 각 부재를 표준규격으로 생산하고, 현장에서 조립하여 안전성 확보",
    isChecked: "",
    title: "작업발판 및 비계",
  },
  {
    content: "시스템비계 설치가 어려워 강관비계를 설치하는 경우 안전난간 및 작업발판의 누락 여부를 철저히 확인한다.",
    isChecked: "",
    title: "작업발판 및 비계",
  },
  {
    content: "비계에서 작업자가 이동할 때에는 반드시 지정된 통로를 이용하도록 관리한다.",
    isChecked: "",
    title: "작업발판 및 비계",
  },
  {
    content: "공정 변화에 따른 작업환경 변화 시 사전에 안전한 작업발판 설치방안 등을 검토한다.",
    isChecked: "",
    title: "작업발판 및 비계",
  },
  {
    content: "이동식비계를 사용할 경우 최상부 안전난간 및 아웃트리거의 설치여부를 철저히 확인한다. ",
    isChecked: "",
    title: "작업발판 및 비계",
  },
  {
    content: "말비계 등 작업장 내에서 수시로 비계를 설치하여 사용하는 경우 사전에 이상 여부를 확인하고, 기준에 따라 사용하는지 관리한다.",
    isChecked: "",
    title: "작업발판 및 비계",
  },
];
